<template>
  <div :class="['container', { 'container-dark': theme_dark }]">
    <input type="file" id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload" />
    <div class="nav-top">
      <div class="nav-left" @click="back()">
        <img src="../../assets/img/返回箭头.png" class="nav-img" />
        <span class="nav-lable"></span>
      </div>
      <div class="nav-middle">礼物投诉</div>
      <div class="nav-right">
        <span class="nav-lable"></span>
        <img src="../../assets/img/返回箭头.png" class="nav-img none" />
      </div>
    </div>

    <div class="content">
      <div class="main">
        <div class="item ub ub-pc ub-ac2">
          <div class="gift ub ub-ver">
            <img :src="gift.gift_url" />
            <span>{{gift.gift_name}}</span>
          </div>

          <div class="send ub ub-ver ub-pc">
            <span>赠送给</span>
            <img src="../../assets/img/右箭头.png" />
            <span>{{gift.dtm}}</span>
          </div>

          <div class="receive ub ub-ver ub-pc">
            <img :src="gift.photo_url" />
            <span>{{gift.nick}}</span>
          </div>
        </div>

        <div class="paper ub">
          <textarea class="ub-f1" placeholder="请输入投诉原因" v-model="txt"></textarea>
        </div>

        <li class="up-block" v-for="(i,index) in ayy_pic" :key="index">
          <img :src="i" @click="show_full(i)" />
        </li>

        <div class="tip ub ub-ac ub-pc"><span>{{tip}}</span></div>
        <div @click="upload_img()" v-if="this.state==''">
          <div class="up ub ub-ver ub-pc ub-ac">
            <img src="../../assets/img/上传截图.png" />
            <span>上传截图证明</span>
          </div>
        </div>

        <div class="ub ub-ac" v-if="this.state==''">
          <div class="btn" @click="save()"><span>提交</span></div>
        </div>
      </div>



      <alert ref="myConfirm"></alert>
      <full_pic ref="myFullPic"></full_pic>
    </div>
  </div>
</template>

<script>
import Exif from "exif-js";
import * as tool from "../../api/common";
import { mapMutations, mapActions } from "vuex";
import full_pic from "../../components/Full_Pic.vue";
import Alert from "../../components/Alert.vue";

export default {
  components: {
    alert: Alert,
    full_pic: full_pic,
  },
  data() {
    return {
      gift_id: "",
      txt: "",
      ayy_pic: [],
      gift: {},
      state: "",
      tip:"",
      theme_dark: false
    };
  },
  mounted() {
    //切换深色模式
    this.theme_dark = tool.is_theme_dark(this);
    var id = this.$route.params.id;
    this.gift_id = id;
    this.init();
    this.init2();
  },
  methods: {
    ...mapMutations(["get", "post", "post2"]), //引入方法

    back() {
      this.$router.go(-1); //返回上一层
    },
    init() {
      var const_data = this.$store.state.const_data;
      var ary_gift = const_data.gift_1.concat(const_data.gift_2);

      var self = this;
      this.get({
        url: "/App/GetGiftOne/" + self.gift_id,
        success: function (data) {
          //console.log(JSON.stringify(data));
          data.photo_url = self.$store.state.url + "/photo/" + data.photo;
          var gift_item = tool.getGiftItemBy_name(ary_gift, data.gift_name);
          data.gift_url = gift_item.url;
          self.gift = data;
        },
      });
    },
    init2() {
      var self = this;
      this.get({
        url: "/App/GetGiftOneData/" + this.gift_id,
        success: function (data) {
          //console.log(JSON.stringify(data));
          if (data.id) {
            var brife = data.brife;
            self.txt = brife;
            var pics = data.pics;
            self.ayy_pic = JSON.parse(pics);
            self.state = data.state;

            if(self.state=="待审核"){
              self.tip="你的投诉信息已提交，请耐心等待平台审核~";
            }
             if(self.state=="通过"){
              self.tip="平台处理结果："+data.rst_check;
            }
             if(self.state=="失败"){
              self.tip="平台处理结果："+data.rst_check;
            }
          }
        },
      });
    },
    save() {
      var txt = this.txt;
      if (txt == "") {
        //会员提示
        this.$toast.center("详细描述不能为空哦");
        return false;
      }
      if(this.ayy_pic==""){
        this.$toast.center("请上传至少一张图片作为证据哦");
        return false;
      }
      var uid = this.$store.state.uid;
      var data_send = {
        uid: uid,
        gift_id: this.gift_id,
        brife: txt,
        pics: JSON.stringify(this.ayy_pic),
        state: "待审核",
      };
      var strsend = JSON.stringify(data_send);
      var self = this;
      this.post({
        url: "/App/Gift_TouSu_Save",
        data: { uid: uid, data: strsend },
        success: function (serve_data) {
          self.$toast.center("您的礼物投诉已提交,请等待平台审核");
          self.state="待审核";
          self.tip="你的投诉信息已提交，请耐心等待平台审核~";

          var bll_id = serve_data.id || "";
          var msg = {
            "txt": "礼物投诉",
            "desc": "",
            "id": bll_id,
            "nick": self.gift.nick
          }
          tool.send_check_msg(self,"check_gift",msg,true);
        },
      });
    },

    upload_img() {
      //触发input的change事件
      var ie =
        navigator.appName == "Microsoft Internet Explorer" ? true : false;
      if (ie) {
        document.getElementById("___file_upload").click();
      } else {
        var a = document.createEvent("MouseEvents"); //FF的处理
        a.initEvent("click", true, true);
        document.getElementById("___file_upload").dispatchEvent(a);
      }
    },
    upload(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.picValue = files[0];

      var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
      var file_name = this.picValue.name;
      var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();

      if (arrExt.indexOf(fileExt) <= -1) {
        //上传文件格式不正确
        this.$toast.center("不支持您所选的图片格式~");
        return false;
      }

      //toast 启动动画
      this.$loading("上传中...");

      this.imgPreview(this.picValue);
    },
    postImg() {
      var self = this;

      //这里写接口
      var base64 = this.headerImage;
      let param = new FormData(); // 创建form对象
      param.append("imgFile", base64); //对应后台接收图片名

      //判断base64 是否成功, 长度>10
      if (base64.length < 10) {
        //消掉动画
        self.$loading.close();
        self.$toast.center("图片处理失败,请重新选择");
        return false;
      }

      this.post2({
        url: "/Common/UpLoadImage_Base64_2",
        data: param,
        success: function (serve_data) {
          //消掉动画
          self.$loading.close();
          //self.$toast.center('上传成功');
          var pic_url = self.$store.state.url + serve_data;
          self.ayy_pic.push(pic_url);
        },

        error: function (err) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("上传失败,请重新再来");
        },
      });
    },
    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function () {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function () {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于4M,是就直接上传，反之压缩图片
          var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(
            2
          );

          if (this.result.length <= 4 * 1024 * 1024) {
            self.headerImage = this.result;

            self.postImg();
          } else {
            img.onload = function () {
              let data = tool.compress(img, Orientation);
              self.headerImage = data;
              self.postImg();
            };
          }
        };
      }
    },
    show_full(url) {
      this.$refs.myFullPic.show(url);
    },
    remove_pic(index) {
      this.ayy_pic.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
#___file_upload {
  position: absolute;
  left: -999px;
}

.container {
  min-height: 100vh;
  background-color: #EFEFEF;
}

.content {
  padding: 0 0.8rem;
  margin-top: 0.5rem;
  .main {
    padding: 1rem 0.8rem;
    border-radius: 0.5rem;
    background-color: #FDFDFD;
    .item {
      .gift {
        img {
          width: 2.5rem;
        }
        span {
          margin-top: 0.5rem;
          font-size: 0.75rem;
          color: #333;
        }
      }
      .send {
        span {
        font-size: 0.65rem;
        color: #333;
      }
      img {
        width: 9rem;
        height: 0.8rem;
      }
      }
      .send span:last-child {
        margin-top: 0.5rem;
      }
      .receive {
        img {
          margin-top: 0.5rem;
          width: 2.5rem;
          border-radius: 50%;
        }
        span {
          margin-top: 0.5rem;
          font-size: 0.75rem;
          color: #333;
        }
      }
    }
    .paper {
      margin-top: 1rem;
      textarea {
        height: 8.5rem;
        outline: none;
        resize: none;
        font-size: 0.9rem;
        padding: 0.35rem 0.55rem;
        line-height: 1.5rem;
        border-radius: 0.25rem;
        color: #333;
        background-color: transparent;
        -webkit-appearance: none;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
      }
      textarea:focus {
        border-color: #333;
      }
    }
    .up-block {
      margin-top: 0.5rem;
      position: relative;
      background-color: transparent;
      img {
        border: 1px dashed #6b6b6b;
        width: 7rem;
      }
      .remove {
        z-index: 3;
        border-radius: 50%;
        width: 0.9rem;
        height: 0.9rem;
        line-height: 1rem;
        text-align: center;
        font-size: 0.9rem;
        background-color: #ff0000;
        color: white;
        position: absolute;
        top: -0.2rem;
        left: 6.5rem;
      }
    }
    .tip{
      margin-top: 1rem;
      padding: 0 .8rem 2rem .8rem;
        span{
        font-size: 0.75rem;
        color: #8A61FF;
      }
    }
    .up {
      width: 7rem;
      height: 7rem;
      background: #49484D;
      border-radius: 0.5rem;
      span {
        color: rgba(255,255,255,0.5);
        font-size: 0.75rem;
      }
      img {
        width: 2rem;
        height: 2rem;
        margin-bottom: 0.5rem;
      }
    }
  }
}

.btn {
  margin-top: 1rem;
  padding: 0.8rem 8rem;
  border-radius: 2rem;
  background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
  span {
    font-size: 0.9rem;
    font-weight: bold;
    color: #fff;
  }
}


.container-dark {
  background-color: #2f2e33;
  .content {
    .main {
      background-color: #2c2b30;
      .gift {
        span {
          color: #fdfdfd;
        }
      }
      .send {
        span {
          color: #888;
        }
      }
      .receive {
        span {
          color: #fdfdfd;
        }
      }
      .paper {
        textarea {
          color: #888;
        }
        textarea:focus {
        border-color: #404040;
      }
      }
    }
  }
}
</style>
